<template>
  <b-col md="12" xl="6">
    <section class="reservation">
      <p class="reservation__title">I dati della tua prenotazione</p>
      <div class="reservation__wrap">
        <div class="reservation__check">
          <span
            class="reservation__date"
            v-html="'Arrivo ' + '<strong class=\'semibold\'>' + reservation.arrival + '</strong>'"
          />
          <span class="reservation__time">{{ reservation.checkin }}</span>
        </div>
        <div class="reservation__check">
          <span
            class="reservation__date"
            v-html="'Partenza ' + '<strong class=\'semibold\'>' + reservation.departure + '</strong>'"
          />
          <span class="reservation__time">{{ reservation.checkout }}</span>
        </div>
      </div>
      <p
        class="reservation__duration"
        v-html="'Durata del soggiorno: <strong class=\'semibold\'>' + reservation.nights + '</strong>'"
      />
      <div class="reservation__info">
        <span class="reservation__info-text semibold">{{ reservation.rooms }} per {{ reservation.guests }}</span>
      </div>
    </section>
  </b-col>
</template>

<script>
import { add } from 'mathjs'
import {format_date_with_month} from '@bookingv3/utilities.js'

export default {
  name: 'reservation',

  components: {
  },

  props: {
    confirm: Object
  },

  data() {
    return {
    }
  },

  computed: {

    // Genera la struttura dati della prenotazione
    reservation() {
      const {bookingVoucher} = this.confirm,
            {checkin, checkout, checkin_phrase, checkout_phrase, nights, rooms, adults, minors} = bookingVoucher

      const nights_label = nights > 1 ? 'notti' : 'notte',
            total_rooms = rooms.length,
            rooms_label = total_rooms > 1 ? 'camere' : 'camera',
            guests = add(adults, minors),
            guests_label = guests > 1 ? 'ospiti' : 'ospite'

      return {
        arrival: format_date_with_month(checkin),
        departure: format_date_with_month(checkout),
        checkin: checkin_phrase,
        checkout: checkout_phrase,
        nights: `${nights} ${nights_label}`,
        rooms: `${total_rooms} ${rooms_label}`,
        guests: `${guests} ${guests_label}`
      }
    }

  },

  created() {
  },

  mounted() {
  },

  methods: {
  },
}
</script>

<style lang="scss" scoped>

  .reservation {
    background-color: #fafcff;
    border-radius: 10px;
    padding: 15px 20px;
    border: 1px solid $gray-300;
    height: 100%;
    margin-top: $grid-gutter-width;

    @include media-breakpoint-up(xl){
      margin-top: 0;
    }

    @media print {
      border: none;
      padding: 0;
      background-color: $white;
    }

    &__title {
      font-size: $font-size-lg;
      font-weight: $vb-font-weight-semibold;
      margin-bottom: 10px;
    }

    &__wrap {
      display: flex;
      align-items: center;
    }

    &__check {
      span {
        display: block;
      }

      &:first-child {
        border-right: 1px solid $gray-300;
        margin-right: 20px;
        padding-right: 20px;
      }
    }

    &__duration {
      margin: 20px 0 0;
    }

    &__info {
      display: flex;
      align-items: center;
    }
  }

</style>